import type { ReactElement } from 'react';
import { useParams } from 'react-router';
import CreateRebalancingRuleForm from '../rebalancingRules/CreateRebalancingRuleForm';

const CreatePortfolioRebalancingRule = (): ReactElement => {
  const { portfolioDefinitionId } = useParams();
  if (!portfolioDefinitionId) {
    throw new Error('Missing portfolio definition');
  }

  return (
    <CreateRebalancingRuleForm
      portfolioDefinitionId={portfolioDefinitionId}
      redirectAfterCreation={`/app/copilot/lab/portfolio/${portfolioDefinitionId}/rebalancing-rules`}
    />
  );
};

export default CreatePortfolioRebalancingRule;
